import React from 'react';
import { AsYouType } from 'libphonenumber-js';
import { debounce } from 'lodash';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import CustomTextField from 'components/CustomTextField/CustomTextField';

export default function AsyncAutocomplete(props) {
	const {
		value,
		searchHandler,
		searchOptions,
		disabled,
		label,
		filterOptions,
		formStateError,
		pageSize = 50,
		onChange,
		onBlur,
		autocompleteClassName,
		isPhoneSearch,
		optionLabel,
	} = props;
	const { sortBy, include } = searchOptions;
	const [options, setOptions] = React.useState([]);
	const [filterQuery, setFilterQuery] = React.useState('');
	const [optionsTotalCount, setOptionsTotalCount] = React.useState(0);
	const [nextPageIndex, setNextPageIndex] = React.useState(0);
	const [loading, setLoading] = React.useState(false);

	const fetchOptions = async () => {
		if (loading) {
			return undefined;
		}

		setLoading(true);

		if (!optionsTotalCount || optionsTotalCount > options.length) {
			try {
				const result = await searchHandler({
					filterQuery,
					pageIndex: nextPageIndex,
					pageSize,
					sortBy,
					include,
				});

				const validOptionsPage = result.data.filter(
					(item) => item[optionLabel]
				);

				if (nextPageIndex === 0) {
					setOptions([...validOptionsPage]);
				} else {
					setOptions([...options, ...validOptionsPage]);
				}
				setNextPageIndex(nextPageIndex + 1);
				setOptionsTotalCount(result.totalCount);
			} catch (error) {
				console.log(error);
			}
		}

		setLoading(false);
	};

	const onQueryChange = async (query) => {
		resetPageParamsOptions();
		setFilterQuery(query);
	};

	const resetPageParamsOptions = async () => {
		setNextPageIndex(0);
		setOptionsTotalCount(0);
	};

	const onScrollBottom = async (event) => {
		const listBoxNode = event.currentTarget;

		if (
			listBoxNode.scrollTop + listBoxNode.clientHeight + 20 >=
			listBoxNode.scrollHeight
		) {
			fetchOptions();
		}
	};

	const debounceOnQueryChange = debounce((filter) => {
		onQueryChange(filter);
	}, 500);

	React.useEffect(() => {
		fetchOptions();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filterQuery]);

	return (
		<Autocomplete
			options={options}
			autoComplete
			includeInputInList
			disabled={disabled}
			value={value}
			loading={loading}
			className={autocompleteClassName}
			getOptionLabel={(option) => {
				if (isPhoneSearch) {
					const phoneNumber = new AsYouType('US').input(
						option[optionLabel]
					);
					return `+${phoneNumber}`;
				}
				return option[optionLabel] || '';
			}}
			filterOptions={filterOptions}
			renderInput={(params) => (
				<CustomTextField
					{...params}
					label={label}
					margin="normal"
					error={!!formStateError}
					helperText={formStateError?.message || ''}
					onChange={(event) => {
						const filter = event.target.value;
						debounceOnQueryChange(filter);
					}}
					InputProps={{
						...params.InputProps,
						endAdornment: (
							<React.Fragment>
								{loading ? (
									<CircularProgress
										color="inherit"
										size={20}
									/>
								) : null}
								{params.InputProps.endAdornment}
							</React.Fragment>
						),
					}}
				/>
			)}
			onChange={(e, val) => {
				onChange && onChange(val);
			}}
			onBlur={() => {
				onBlur && onBlur();
			}}
			onOpen={() => {
				fetchOptions();
			}}
			onClose={() => {
				setFilterQuery('');
				setOptions([]);
				resetPageParamsOptions();
			}}
			ListboxProps={{
				onScroll: (event) => onScrollBottom(event),
			}}
		/>
	);
}
